import { updateVanityNav } from "@bracket/contractor-next/bracket-vault";
import { type BlockHash, isBlockHash, type WEIString } from "@bracket/types";
import { isUserWalletRejection } from "@utils";
import { wagmiConfig as config } from "@wagmiconfig";

export declare type ProcessVanityNavUpdateResult =
	| {
			success: true;
			hash: BlockHash;
	  }
	| {
			success: false;
			rejected: true;
	  }
	| {
			success: false;
			rejected: false;
			error: Error;
	  };


export const processVanityNavUpdate = async ( address: string, nav: WEIString, ): Promise<ProcessVanityNavUpdateResult> => {

	try {

		const hash = await updateVanityNav({
			vault: address,
			newNav: nav,
			config,
		});

		if(isBlockHash(hash)) {
			return {
				success: true,
				hash,
			};
		}

		throw new Error("processClaimManagerTvlFees failed to produce a valid blockhash");
	}
	catch (err) {
	
		if(isUserWalletRejection(err)) {
			return {
				success: false,
				rejected: true,
			};
		}

		return {
			success: false,
			rejected: false,
			error: err as Error,
		};

	}

};
